import * as React from 'react';
var RadioGroupContext = React.createContext(null);
export var RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;